/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export interface PortalListingRevealPhoneResponseDto {
  /** @nullable */
  phone: string | null;
}
